import React, { useEffect, useState } from "react";
import explore_products_1 from "../../../assets/images/dummy/explore_products_1.png";
import explore_products_2 from "../../../assets/images/dummy/explore_products_2.jpeg";
import rightArrow from "../../../assets/images/icons/rightArrow.png";

import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Badge, Button, Col, Container, Row } from "react-bootstrap";
import Y_Us_StripComponent from "../../common/Y_us_strip";
import { Link, NavLink, useLocation, useNavigation } from "react-router-dom";
import Filter from "../../../components/Filter";
import Constants from "../../Variables/Constants";
import qs from "qs";
import ReactPaginate from "react-paginate";
import axios from "axios";
import { toast } from "react-toastify";
import Product from "../Product";
import NoData from "../../../components/NoData";
import Loader from "../../../components/Loader";

function ParochetPagesComponet() {
  const location = useLocation();
  // const { title, description, category, _id } = location.state;
  const _id = location.search.split("=").at(-1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [productList, setProductList] = useState([]);
  const [flag, setFlag] = useState(false);
  const [collectionList, setCollectionList] = useState([]);
  const [isBag, setIsBag] = useState(false);
  const [searchPayload, setSearchPayload] = useState({
    search: "",
    sortBy: "",
    startDate: "",
    endDate: "",
  });
  const [loader, setLoader] = useState(false);
  const [categoryData, setCategoryData] = useState("");

  const getCategoryDetail = async () => {
    try {
      setLoader(true);
      const resp = await axios.get(
        `${Constants.getUrls.getAllCategory}/${_id}`
      );
      if (resp.data.status === "success") {
        setCategoryData(resp?.data?.data);
        setLoader(false);
      } else {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(resp.data.message);
      }
    } catch (error) {
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data;
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      }
    }
  };

  const getCollections = async () => {
    try {
      setLoader(true);
      const resp = await axios.get(
        `${Constants.getUrls.getAllCollections}?limit=${100}&cateId=${_id}`
      );
      if (resp.data.status === "success") {
        const data = resp.data.data.docs;
        if (data && Array.isArray(data) && data.length > 0) {
          setCollectionList(data);
        }
        setLoader(false);

        // if (resp.data.data.docs.length > 0) {
        //   stylesChange(resp.data.data.docs[0]._id);
        // }
      }
    } catch (error) {
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data;
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      }
    }
  };

  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1); // Update the current page
  };

  const handleGetAllProduct = async ({ payload, url }) => {
    try {
      setLoader(true);
      axios
        .get(`${url}?${qs.stringify(payload)}`)
        .then((resp) => {
          if (resp.data.status === "success") {
            const data = resp.data.data.docs;
            if (data && Array.isArray(data) && data.length > 0) {
              setProductList(data);
            } else {
              setProductList([]);
            }
            setTotalPages(resp?.data?.data?.totalPages);
            setLoader(false);
          } else {
            toast.clearWaitingQueue();
            toast.dismiss();
            toast.error(resp.data.message);
          }
        })
        .catch((error) => {
          toast.clearWaitingQueue();
          toast.dismiss();
          toast.error(error.message);
        });
    } catch (error) {
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data;
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      }
    }
  }

  const getAllProducts = ({ payload, url }) => {

    try {
      setLoader(true);
      axios
        .get(`${url}?${qs.stringify(payload)}`)
        .then((resp) => {
          if (resp.data.status === "success") {
            const data = resp.data.data.docs;
            if (data && Array.isArray(data) && data.length > 0) {
              setProductList(data);
            } else {

              const payload = {
                page: currentPage,
                limit: 10,
                category: _id,
                created_by: "admin",
                ...searchPayload,
              };

              const url = Constants.getUrls.getAllProducts
              handleGetAllProduct({ payload, url });
            }
            setTotalPages(resp?.data?.data?.totalPages);
            setLoader(false);
          } else {
            const payload = {
              page: currentPage,
              limit: 10,
              category: _id,
              created_by: "admin",
              ...searchPayload,
            };

            const url = Constants.getUrls.getAllProducts
            handleGetAllProduct({ payload, url });
          }
        })
        .catch((error) => {
          toast.clearWaitingQueue();
          toast.dismiss();
          toast.error(error.message);
        });
    } catch (error) {
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data;
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      }
    }
  };

  useEffect(() => {
    if (_id) {
      if (categoryData && categoryData.title && categoryData.title === "Tallis/Tefillin Bags" || categoryData && categoryData.title && categoryData.title === "Custom Passover Sets") {
        setIsBag(true);
        const payload = {
          page: currentPage,
          limit: 10,
          category: _id,
          ...searchPayload,
        };

        const url = Constants.getUrls.getAllCustomizedProducts
        getAllProducts({ payload, url });
      } else {
        setIsBag(false);
        const payload = {
          page: currentPage,
          limit: 10,
          category: _id,
          created_by: "admin",
          ...searchPayload,
        };

        const url = Constants.getUrls.getAllProducts
        getAllProducts({ payload, url });
      }
    }
  }, [_id, flag, searchPayload, currentPage, categoryData]);



  useEffect(() => {
    if (_id) {
      getCategoryDetail();
      getCollections();
    }
  }, [_id]);
  return (
    <>
      <section className="mt-3">
        {/* <div className="m-5 d-flex justify-content-center flex-wrap">
          <iframe width="560" height="315" src="https://www.youtube.com/embed/LQrjpFMCE9U?si=5Fj2F7ZHwbDs-VAx" title="YouTube video player" style={{ border: "none" }} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

          <iframe width="560" height="315" src="https://www.youtube.com/embed/2f2Kt8e6htw?si=hXgdfj6qh680aVmu" title="YouTube video player" style={{ border: "none" }} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

        </div> */}
        {loader && <Loader />}
        <div className="container-fluid px-5">
          <nav className="my-5 font-poppins route-navigation">
            <ul className="d-flex gap-4 text-light-gray fs-20 fw-bold ">
              <NavLink to={"/"}>
                {" "}
                <li className="list-unstyled">HOME</li>
              </NavLink>
              <li className="list-unstyled">
                <img src={rightArrow} alt="" />
              </li>
              <NavLink to={`/category?catid=${categoryData?._id}`}>
                <li className="list-unstyled text-dark">
                  {categoryData?.title}
                </li>
              </NavLink>
            </ul>
          </nav>
          <Row>
            <Col sm="7">
              <div className="parochet_card_img d-flex justify-content-center">
                <img
                  src={`${Constants.imgDomain}${categoryData?.category}`}
                  alt="category"
                  style={{
                    width: "100%",
                    maxWidth: "400px",
                    height: "300px",
                    objectFit: "cover",
                  }}
                  className="rounded-4"
                />
              </div>
            </Col>
            <Col sm="5">
              <div className="parochet_card_bg">

                <iframe height="315" src="https://www.youtube.com/embed/LQrjpFMCE9U?si=5Fj2F7ZHwbDs-VAx" title="YouTube video player" style={{ border: "none", width: "100%" }} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                {/* <h4 className="">{categoryData?.title}</h4>
                  <p>{categoryData?.description}</p> */}

              </div>
            </Col>
          </Row>
        </div>
      </section>

      <section className="section_padding gg home_explore_our_products">
        <div className="container-fluid px-5">
          <div className="d-flex mb-3">
            <h2 className="hdng1">Explore the collections</h2>
          </div>
          <Col>
            <div className="row w-100 justify-content-start align-items-start">
              {collectionList.map((collection, index) => (
                <div
                  className="explore_our_products_card col-lg-3 col-md-4 col-sm-6 col-12"
                  key={collection?._id}
                >

                  <div className="d-flex w-100 mt-2 px-3 justify-content-between align-items-center">
                    <p className="product_name">{collection?.title}</p>
                    <p className="product_price text-orange">
                      (
                      {isBag === true ? (<>
                        {
                          collection?.products?.filter((io) => io.status === "active" && io?.is_delete === "no")?.length
                        }
                      </>) : (<>
                        {collection?.products?.filter((io) => io.status === "active" && io?.is_delete === "no" && io?.created_by === "admin")?.length}
                      </>)}
                      )
                    </p>
                  </div>
                  <NavLink
                    // to={`/category/collection?catid=${categoryData?._id}&collectionId=${collection?._id}`}
                    to={`/customize?categoryId=${categoryData?._id}&collectionId=${collection?._id}`}

                    state={{
                      categoryId: _id,
                      collectionId: collection?._id,
                    }}
                  >
                    <img
                      src={`${Constants.imgDomain}${collection?.subCategory}`}
                      alt={`banner-${index + 1}`}
                      style={{ objectFit: "fill" }}
                    />
                  </NavLink>
                </div>
              ))}

              {collectionList.length === 0 && (
                <NoData
                  image={
                    "https://static.vecteezy.com/system/resources/thumbnails/010/856/652/small_2x/no-result-data-document-or-file-not-found-concept-illustration-flat-design-eps10-modern-graphic-element-for-landing-page-empty-state-ui-infographic-icon-etc-vector.jpg"
                  }
                  text={""}
                />
              )}
            </div>
          </Col>
          <hr
            className="my-4"
            style={{ borderTop: "1px solid #000000", opacity: "1" }}
          />
        </div>
      </section>

      <div className="px-5">
        <div className="d-flex justify-content-between align-items-center">
          <h2 className="hdng1">The Most Bought</h2>
          <Filter
            searchPayload={searchPayload}
            setSearchPayload={setSearchPayload}
          />
        </div>
      </div>

      {productList.length === 0 && (
        <NoData
          image={"https://bepharco.com/no-products-found.png"}
          text={""}
        />
      )}
      {productList.length > 0 && (
        <>
          <section>
            <div className="container-fluid px-5">
              <Row className="g-4 mt-5">
                {productList.map((product, index) => (
                  <Col sm="6" md="6" lg="4" xl="3" key={product?._id} xxl="3">
                    <Product
                      product={product}
                      flag={flag}
                      setFlag={setFlag}
                      categoryId={product?.category?._id}
                      collectionId={product?.sub_category?._id}
                    />
                  </Col>
                ))}
              </Row>

              <Row>
                <Col md={12} className="d-flex justify-content-center">
                  <ReactPaginate
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    pageCount={totalPages}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                    previousClassName={"page-item"}
                    previousLinkClassName={"page-link"}
                    nextClassName={"page-item"}
                    nextLinkClassName={"page-link"}
                    breakClassName={"page-item"}
                    breakLinkClassName={"page-link"}
                    activeClassName={"active"}
                  />
                </Col>
              </Row>
            </div>
          </section>
        </>
      )}
      <Y_Us_StripComponent />
    </>
  );
}

export default ParochetPagesComponet;
